import { useMutation } from "@tanstack/react-query";
import { visitEntity } from "../services/visit.service";

interface UseEntityVisitMutationProps {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useEntityVisitMutation = ({ onSuccess, onError }: UseEntityVisitMutationProps = {}) => {
  return useMutation({
    mutationFn: visitEntity,
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error: Error) => {
      onError?.(error);
    },
  });
};
